import React from "react";
import { UserSettings } from "../../Models/UserSettings";
import { ToggleSetting } from "../../../Layout";
import { UserSettingName } from "../../Constants/UserSettingName";

type Props = {
  settings: UserSettings;
  onSetSetting: (key: string, value: string, action: () => void) => void;
};

type State = {
  feedbackSubscriptionNotifications: boolean;
  feedbackStateNotifications: boolean;
  commentNotifications: boolean;
  commentPingNotifications: boolean;
};

export class NotificationSettings extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { settings } = props;

    this.state = {
      feedbackSubscriptionNotifications: settings.feedbackSubscriptionNotifications,
      feedbackStateNotifications: settings.feedbackStateNotifications,
      commentNotifications: settings.commentNotifications,
      commentPingNotifications: settings.commentPingNotifications
    };
  }

  toggleFeedbackSubscriptionNotifications = () => {
    const { onSetSetting } = this.props;
    const { feedbackSubscriptionNotifications } = this.state;
    onSetSetting(
      UserSettingName.FeedbackSubscriptionNotifications,
      String(!feedbackSubscriptionNotifications),
      () => {
        this.setState(prevState => ({
          feedbackSubscriptionNotifications: !prevState.feedbackSubscriptionNotifications
        }));
      }
    );
  };

  toggleFeedbackStateNotifications = () => {
    const { onSetSetting } = this.props;
    const { feedbackStateNotifications } = this.state;
    onSetSetting(
      UserSettingName.FeedbackStateNotifications,
      String(!feedbackStateNotifications),
      () => {
        this.setState(prevState => ({
          feedbackStateNotifications: !prevState.feedbackStateNotifications
        }));
      }
    );
  };

  toggleFeedbackCommentNotifications = () => {
    const { onSetSetting } = this.props;
    const { commentNotifications } = this.state;
    onSetSetting(UserSettingName.CommentNotifications, String(!commentNotifications), () => {
      this.setState(prevState => ({
        commentNotifications: !prevState.commentNotifications
      }));
    });
  };

  toggleFeedbackCommentPingNotifications = () => {
    const { onSetSetting } = this.props;
    const { commentPingNotifications } = this.state;
    onSetSetting(
      UserSettingName.CommentPingNotifications,
      String(!commentPingNotifications),
      () => {
        this.setState(prevState => ({
          commentPingNotifications: !prevState.commentPingNotifications
        }));
      }
    );
  };

  render() {
    const {
      feedbackSubscriptionNotifications,
      feedbackStateNotifications,
      commentNotifications,
      commentPingNotifications
    } = this.state;

    return (
      <div>
        <div>
          <h5>Feedback Notifications</h5>
          <ToggleSetting
            state={feedbackSubscriptionNotifications}
            settingName="Receive notifications for applications that you are subscribed to"
            settingDescription="By enabling this you will receive a notification whenever someone creates a feedback in an application you are subscribed to"
            onToggle={this.toggleFeedbackSubscriptionNotifications}
            labeled
          />
          <br />
          <ToggleSetting
            state={feedbackStateNotifications}
            settingName="Receive notifications for feedback you are watching"
            settingDescription="By enabling this you will receive notification when the state of any feedback you are watching changes"
            onToggle={this.toggleFeedbackStateNotifications}
            labeled
          />
          <br />
          <ToggleSetting
            state={commentNotifications}
            settingName="Receive notifications when someone comments on something you created"
            settingDescription="By enabling this you will receive notification when someone comments on your feedback, or replies to a comment of yours"
            onToggle={this.toggleFeedbackCommentNotifications}
            labeled
          />
          <br />
          <ToggleSetting
            state={commentPingNotifications}
            settingName="Receive notifications when you are mentioned in a comment"
            settingDescription="By enabling this you will receive notification when someone mentions you in a comment on a feedback"
            onToggle={this.toggleFeedbackCommentPingNotifications}
            labeled
          />
        </div>
      </div>
    );
  }
}
